<template>
    <div id="aia_header">
        <div class="aia-search-header"
            :class="[{'aia-header-mass' : theme == 'mass'}, {'aia-header-prestige' : theme == 'prestige'}]">
            <img class="aia-search-back img-fluid" 
                src="@/assets/icon/ic-back@3x.png"
                @click="onBack()" />
            <div class="aia-search">
                <input id="search_input_header"
                    :class="[{'search-input-mass' : theme == 'mass'}, {'search-input-prestige' : theme == 'prestige'}]"
                    @input="onChange()"
                    @keyup.enter="onEnter()"
                    :placeholder="lbl.header.placeholder"
                    v-model="searchTxt" />
                <img id="search_remove"
                    src="@/assets/icon/ic_clear.svg"
                    v-if="searchTxt"
                    @click="onClear()" />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'AIAHeaderSearch',
    props: {
        // v-model 
        value: { type: String },
        // props
        lbl: { type: Object }
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    watch: {
        value: function (newVal) {
            this.searchTxt = newVal;
        }
    },
    data: function () {
        return {
            searchTxt: this.value
        };
    },
    methods: {
        //event
        onBack: function () {
            this.$emit('onBack');
        },
        onChange: function () {
            let result = this.searchTxt;
            result = result.replace(Vue.RegExp.emoji, '');
            result = result.replace(Vue.RegExp.symbol, '');

            this.searchTxt = result;
            this.$emit('input', result);
        },
        onClear: function () {   
            this.searchTxt = '';
            this.$emit('input', '');
            this.$emit('onClear');
        },
        onEnter: function () {
            this.$emit('onSearch');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.aia-search-header {
    @extend %display-flex;
    padding: 20px;

    &.aia-header-mass {
        background-color: $mass_theme_color;
    }   

    &.aia-header-prestige {
        background-color: $prestige_theme_color;
    }

    .aia-search-back {
        width: 18px;
        flex: 0 0 18px;
        margin: {
            top: auto;
            bottom: auto;
        }
    }

    .aia-search {
        position: relative;
        width: calc(100% - 18px);
        flex: 0 0 calc(100% - 18px);
        padding-left: 15px;

        #search_input_header {
            width: 100%;
            height: 40px;
            padding: 12px 35px 12px 10px;
            border: solid 1px #c4c4c4;
            border-radius: 8px;
            // font-family: $heading;
            font-size: 1.2rem;

            &:focus {
                outline: none;
            }

            &::-webkit-input-placeholder { /* Edge */
                color: #c4c4c4;
            }

            &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color: #c4c4c4;
            }

            &::placeholder {
                color: #c4c4c4;
            }

            &.search-input-mass {
                color: $mass_theme_color;
            }
           
            &.search-input-prestige {
                color: $prestige_theme_color;
            }
        }

        #search_remove {
            position: absolute;
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
        }
    }
}
</style>